<script>
import texts from '../assets/data/localisations.json'

export default {
  props: {
    topicId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      texts: null,
      isNeutral: true,
      userInput: false,
    }
  },
  computed: {
    locale() {
      return this.$store.getters['globals/locale']
    },
    params() {
      return this.$store.getters['globals/params']
    },
    isOldApp() {
      return this.$store.getters['globals/oldApp']
    },
    displayText() {
      if (this.isNeutral) {
        return this.texts[this.locale].ishelpful
      } else if (!this.isNeutral && !this.userInput) {
        return this.texts[this.locale].nothelpful
      } else {
        return this.texts[this.locale].washelpful
      }
    },
  },
  created() {
    this.texts = texts
  },
  methods: {
    contactUrl() {
      if (this.isOldApp) {
        location.replace('https://outfit7.com/game-support/#contact-anchor')
      } else {
        this.$router.push({ name: 'contact' })
      }
    },
    yes() {
      this.isNeutral = false
      this.userInput = true
      this.$plausible.trackEvent('click', {
        props: {
          eventCategory: this.topicId,
          eventAction: this.params.aId,
          eventLabel: 'Yes'
        }
      })

    },
    no() {
      this.isNeutral = false
      this.userInput = false
      this.$plausible.trackEvent('click', {
        props: {
          eventCategory: this.topicId,
          eventAction: this.params.aId,
          eventLabel: 'Yes'
        }
      })
    },
  },
}
</script>

<template>
  <div class="feedback md-elevation-4">
    <div class="feedback_text">{{ displayText }}</div>
    <md-button v-if="isNeutral" class="md-primary feedback_btn" @click="no">{{
      texts[locale].no
    }}</md-button>
    <md-button v-if="isNeutral" class="md-primary feedback_btn" @click="yes">{{
      texts[locale].yes
    }}</md-button>
    <md-button
      v-if="!isNeutral && !userInput"
      class="md-primary feedback_btn"
      @click="contactUrl"
      >{{ texts[locale].contactus }}</md-button
    >
  </div>
</template>

<style lang="scss">
.feedback {
  width: 100%;
  position: fixed;
  display: flex;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #eee;

  .feedback_text {
    line-height: 3.4em;
    padding: 0px 0px 0 10px;
  }

  .feedback_btn {
    margin-left: auto;
    margin-right: 10px;
  }
}

.ru .feedback .feedback_text,
.ja .feedback .feedback_text {
  line-height: 4.1em;
  padding: 0px 0px 0 10px;
  font-size: 0.75em;
}

.ar .feedback .feedback_text {
  padding: 0px 10px 0 10px;
}

.vi .feedback .feedback_text {
  line-height: 2.4em;
}

.ja .feedback .md-button,
.it .feedback .md-button,
.es .feedback .md-button,
.pt .feedback .md-button,
.zh .feedback .md-button,
.de .feedback .md-button,
.ko .feedback .md-button,
.ar .feedback .md-button,
.ru .feedback .md-button,
.vi .feedback .md-button,
.id .feedback .md-button {
  min-width: 60px;
}

.th .feedback .md-button {
  min-width: 56px;
}
</style>
